class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // disable native click toggle on summary
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => e.preventDefault());
    }

    // add hover listeners
    this.addHoverListeners();

    // still keep focus handling (keyboard nav)
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  addHoverListeners() {
    const submenu = this.querySelector('.js-header-submenu');
    let isInside = false;
    let moveListener;
  
    const openMenu = () => {
      this.open();
      isInside = true;
      document.removeEventListener('mousemove', moveListener);
    };
  
    const scheduleClose = () => {
      isInside = false;
  
      // track mouse after leaving
      moveListener = (e) => {
        const rect1 = this.mainDetailsToggle.getBoundingClientRect();
        const rect2 = submenu ? submenu.getBoundingClientRect() : null;
  
        const inDetails =
          e.clientX >= rect1.left &&
          e.clientX <= rect1.right &&
          e.clientY >= rect1.top &&
          e.clientY <= rect1.bottom;
  
        const inSubmenu =
          rect2 &&
          e.clientX >= rect2.left &&
          e.clientX <= rect2.right &&
          e.clientY >= rect2.top &&
          e.clientY <= rect2.bottom;
  
        if (!inDetails && !inSubmenu) {
          this.close();
          document.removeEventListener('mousemove', moveListener);
        }
      };
  
      document.addEventListener('mousemove', moveListener);
    };
  
    this.mainDetailsToggle.addEventListener('mouseenter', openMenu);
    this.mainDetailsToggle.addEventListener('mouseleave', scheduleClose);
  
    if (submenu) {
      submenu.addEventListener('mouseenter', openMenu);
      submenu.addEventListener('mouseleave', scheduleClose);
    }
  }
  

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', true);
    this.onToggle();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
    this.onToggle();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);